import React from "react";
import NewsletterSeventeen from "../component/NewsletterSeventeen";

function NewsletterSeventeenContainer() {
  return <NewsletterSeventeen />;
}

export default NewsletterSeventeenContainer;
